import { type FC } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, SpinAnimation } from "@twioku/common_components";
import { useRequireAgreedAnswerer } from "../features/answerer/hooks/useRequireAgreedAnswerer";
import { useUserQuestion } from "../features/question/hooks/useUserQuestion";
import { AnswererProfileImage } from "../components/AnswererProfileImage";
import { Path } from "../routes/PagePath";

export const SentQuestionDetailPage: FC = () => {
    const params = useParams();
    const id = params.id as string;
    const answererId = params.answererId as string;
    const { question, isLoading: isGetQuestionLoading } = useUserQuestion(id);
    const {
        answerer,
        isLoading: isGetAnswererLoading,
        isAgreed,
    } = useRequireAgreedAnswerer(answererId);
    const navigate = useNavigate();
    if (isGetQuestionLoading || isGetAnswererLoading) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    if (!answerer || !question || !isAgreed) {
        navigate(Path.notFound, { replace: true });
        return null;
    }

    return (
        <div className="px-4 pb-8 pt-2">
            <div className="mb-4 flex items-center gap-2">
                <AnswererProfileImage
                    answererId={answerer.answererId}
                    src={answerer.profileImagePath}
                    imageSize="medium"
                />
                <p className="text-sm">{answerer.name}さん 向けの質問</p>
            </div>

            <div className="ml-1 mt-5">
                <span className="text-lg">送付した質問</span>
                <div className="mt-2">
                    <div className="mx-auto h-full w-full rounded-lg border px-4 pb-8 pt-2">
                        {question.title}
                    </div>
                </div>
            </div>
            <span className="text-xs text-gray-600">
                ※既に送付済みの質問のため、修正はできません。お返事をお待ち下さい。
            </span>
            <div className="fixed bottom-0 left-1/2 w-full -translate-x-1/2 bg-white text-center">
                <Button
                    onClick={() =>
                        navigate(`${Path.questionList}/${answererId}`)
                    }
                    variant="outline"
                    className="mb-8 mt-2 h-12 w-11/12"
                >
                    一覧へ戻る
                </Button>
            </div>
        </div>
    );
};
